import React from 'react';

function formatDate(dateString) {
    if (!dateString) return 'Date TBA';
    return new Date(dateString).toLocaleDateString();
}

function formatTime(dateString) {
    if (!dateString) return 'Time TBA';
    return new Date(dateString).toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
    });
}

function isInsideTelegram() {
    return !!window.Telegram?.WebApp;
}

function openBot() {
    if (isInsideTelegram()) {
        window.open('https://t.me/y_fight_bot?startapp', '_blank');
        return;
    }

    window.location.href = 'tg://resolve?domain=y_fight_bot&startapp';

    setTimeout(() => {
        window.open('https://t.me/y_fight_bot?startapp', '_blank');
    }, 500);
}

function openCommunity() {
    if (isInsideTelegram()) {
        window.open('https://t.me/y_fight', '_blank');
        return;
    }

    window.location.href = 'tg://resolve?domain=y_fight';

    setTimeout(() => {
        window.open('https://t.me/y_fight', '_blank');
    }, 500);
}

function PublicView({ featuredEvent, events = [] }) {
    const safeEvents = Array.isArray(events) ? events : [];

    return (
        <div className="container">
            <h1>Y FIGHT</h1>
            <div className="tagline">
                Multi-event fight platform
            </div>

            {featuredEvent && (
                <div className="featured-event">
                    <h2>{featuredEvent.title}</h2>

                    <div className="event-meta">
                        <div className="event-meta-item">
                            <span className="event-meta-icon">📅</span>
                            <span>{formatDate(featuredEvent.startsAt)}</span>
                        </div>

                        <div className="event-meta-item">
                            <span className="event-meta-icon">⏰</span>
                            <span>{formatTime(featuredEvent.startsAt)}</span>
                        </div>

                        <div className="event-meta-item">
                            <span className="event-meta-icon">📍</span>
                            <span>{featuredEvent.venue?.name || 'Venue TBA'}</span>
                        </div>

                        <div className="event-meta-item">
                            <span className="event-meta-icon">🏠</span>
                            <span>{featuredEvent.venue?.address || 'Address TBA'}</span>
                        </div>

                        <div className="event-meta-item">
                            <span className="event-meta-icon">👥</span>
                            <span>{featuredEvent.registrationCount || 0} / {featuredEvent.capacity}</span>
                        </div>
                    </div>

                    <div className="public-cta-row">
                        <button
                            type="button"
                            className="cta-main"
                            onClick={openBot}
                        >
                            Sign up using Telegram
                        </button>
                    </div>
                </div>
            )}

            {safeEvents.length > 1 && (
                <div className="event-list">
                    <h3>Other Upcoming Events</h3>

                    <div className="event-grid">
                        {safeEvents.slice(1).map((e) => (
                            <div key={e._id} className="event-card">
                                <div className="event-card-title">{e.title}</div>

                                <div className="event-card-meta">
                                    <div>{formatDate(e.startsAt)}</div>
                                    <div>{formatTime(e.startsAt)}</div>
                                    <div>{e.venue?.name || 'Venue TBA'}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            <div className="action-row community-row">
                <div className="qr-small qr-desktop-only">
                    <img src="/qr-link.jpeg" alt="Community Link" />
                </div>

                <div className="cta-text">
                    <p>Community</p>
                    <button
                        type="button"
                        className="cta-secondary"
                        onClick={openCommunity}
                    >
                        Join Community
                    </button>
                </div>
            </div>

            <div className="footer">
                Powered by <a href="https://ensopeople.org">Enso People</a>
            </div>
        </div>
    );
}

export default PublicView;